import React from "react";
import PropTypes from 'prop-types';
import CardDesignView from "../../../components/CardDesignView";
import {IconButton, Typography, withStyles} from "@material-ui/core";
import SvgIcon from "@material-ui/core/SvgIcon";
import grey from "@material-ui/core/colors/grey";

const styles = (theme) => ({
  headerTitle: {
    marginTop: 16,
    marginBottom: 0,
    fontWeight: 300,
    textAlign: 'center'
  },
  cardDesignsSelectButton: {
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  cardDesignContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    // position: 'relative',
    // top: -25,
    // height: 160
  },
  cardDesignDescription: {
    fontWeight: 200,
    fontSize: 14,
    paddingLeft: 16,
    paddingRight: 16
  },
  compactCardDesignHeaderContainer: {
    height: 92,
    overflow: 'hidden',
    marginBottom: 8,
    borderBottom: 'solid 2px ' + grey[300],
  },
  compactCardDesignContainer: {
    display: 'flex',
    position: 'relative'
  },
  cardDesignThumbnailsContainer: {
    display: 'flex',
    flexDirection: 'rows',
    flexWrap: 'wrap',
    justifyContent: 'center',
    maxWidth: 500
  },
  cardDesignThumbnail: {
    padding: 2,
    margin: 2,
    borderRadius: 4,
    borderColor: 'transparent',
    borderWidth: 2,
    borderStyle: 'solid',
    '&:hover': {
      borderRadius: theme.shape.borderRadius,
      borderColor: 'black',
      borderWidth: 2,
      borderStyle: 'solid',
    }
  },
  selectedCardDesignThumbnail: {
    padding: 2,
    margin: 2,
    borderRadius: 4,
    borderColor: theme.palette.primary.main,
    borderWidth: 2,
    borderStyle: 'solid',
  },
  nextIcon: {
    width: 56,
    height: 56
  },
  prevIcon: {
    width: 56,
    height: 56
  },

});

CardDesignSection.propTypes = {
  checkoutSettings: PropTypes.object,
  currencyCode: PropTypes.string,
  cardDesigns: PropTypes.array,
  availableCardDesignIds: PropTypes.array,
  cardDesign: PropTypes.object,
  selectedCardDesignIndex: PropTypes.number,
  pricing: PropTypes.object,
  amount: PropTypes.number,
  locale: PropTypes.string.isRequired,
  theme: PropTypes.object,
  onCardDesignChange: PropTypes.func.isRequired,
  classes: PropTypes.object
};

function CardDesignSection({
                             checkoutSettings,
                             currencyCode,
                             selectedCardDesignIndex,
                             cardDesigns,
                             availableCardDesignIds,
                             amount,
                             locale,
                             onCardDesignChange,
                             theme,
                             classes
                           }) {

  function handlePreviousCardDesignClick() {
    let newSelectedCardDesignIndex = selectedCardDesignIndex;
    let cardDesignAvailable = false;
    do {
      if (newSelectedCardDesignIndex === 0) {
        newSelectedCardDesignIndex = cardDesigns.length - 1;
      } else {
        newSelectedCardDesignIndex = newSelectedCardDesignIndex - 1;
      }
      const newSelectedCardDesign = cardDesigns[newSelectedCardDesignIndex];
      cardDesignAvailable = newSelectedCardDesign != null && availableCardDesignIds.includes(newSelectedCardDesign.id);
    } while(!cardDesignAvailable);

    onCardDesignChange(cardDesigns[newSelectedCardDesignIndex], newSelectedCardDesignIndex);
  }

  function handleNextCardDesignClick() {
    let newSelectedCardDesignIndex = selectedCardDesignIndex;
    let cardDesignAvailable = false;

    do{
      if (newSelectedCardDesignIndex < cardDesigns.length - 1) {
        newSelectedCardDesignIndex = newSelectedCardDesignIndex + 1;
      } else {
        newSelectedCardDesignIndex = 0;
      }
      const newSelectedCardDesign = cardDesigns[newSelectedCardDesignIndex];
      cardDesignAvailable = newSelectedCardDesign != null && availableCardDesignIds.includes(newSelectedCardDesign.id);
    } while(!cardDesignAvailable);

    onCardDesignChange(cardDesigns[newSelectedCardDesignIndex], newSelectedCardDesignIndex);
  }

  function handleOnSelectCardDesignClick(newSelectedCardDesignIndex) {
    if (newSelectedCardDesignIndex !== selectedCardDesignIndex) {
      onCardDesignChange(cardDesigns[newSelectedCardDesignIndex], newSelectedCardDesignIndex);
    }
  }

  function renderCardDesign() {
    const hasMultipleCardDesigns = cardDesigns.length > 1;
    const showCardDesignSelectButtons = hasMultipleCardDesigns;

    return (
      <div className={classes.cardDesignContainer}>
        {showCardDesignSelectButtons &&
        <IconButton
          className={classes.cardDesignsSelectButton}
          onClick={handlePreviousCardDesignClick}
        >
          <SvgIcon htmlColor={theme.palette.secondary.main} viewBox={'0 0 64 64'} className={classes.prevIcon}>
            <circle cx="32" cy="32" fill="none" r="24" stroke={theme.palette.secondary.main} strokeLinecap="round" strokeLinejoin="round"
                    strokeMiterlimit="10" strokeWidth="2"/>
            <polyline fill="none" points="  35.9,43.7 24.1,32 35.8,20.3 " stroke={theme.palette.secondary.main} strokeLinecap="round"
                      strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2"/>
          </SvgIcon>
        </IconButton>
        }
        <CardDesignView
          locale={locale}
          currencyCode={currencyCode}
          balance={amount}
          cardDesign={cardDesigns[selectedCardDesignIndex]}
        />
        {showCardDesignSelectButtons &&
        <IconButton
          className={classes.cardDesignsSelectButton}
          onClick={handleNextCardDesignClick}
        >
          <SvgIcon htmlColor={theme.palette.secondary.main} viewBox={'0 0 64 64'} className={classes.nextIcon}>
            <circle cx="32" cy="32" fill="none" r="24" stroke={theme.palette.secondary.main} strokeLinecap="round" strokeLinejoin="round"
                    strokeMiterlimit="10" strokeWidth="2"/>
            <polyline fill="none" points="  28.1,20.3 39.9,32 28.2,43.7 " stroke={theme.palette.secondary.main} strokeLinecap="round"
                      strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2"/>
          </SvgIcon>
        </IconButton>
        }
      </div>
    );
  }

  function renderDescription() {
    const cardDesign = cardDesigns[selectedCardDesignIndex];
    const {description} = cardDesign;

    if (description) {
      return (
        <Typography variant={'body1'} className={classes.cardDesignDescription}>
          {description}
        </Typography>
      );
    }
  }

  function renderCardDesignThumbnails() {
    const hasMultipleCardDesigns = cardDesigns.length > 1;

    if (!hasMultipleCardDesigns) {
      return;
    }

    return (
      <div className={classes.cardDesignThumbnailsContainer}>
        {cardDesigns.map((cardDesign, cardDesignIndex) => {
          const cardDesignThumbnailClass = cardDesignIndex === selectedCardDesignIndex ? classes.selectedCardDesignThumbnail : classes.cardDesignThumbnail;
          if(availableCardDesignIds.includes(cardDesign.id)) {
            return (
              <div className={cardDesignThumbnailClass} onClick={() => handleOnSelectCardDesignClick(cardDesignIndex)} key={cardDesign.id}>
                <CardDesignView
                  cardDesign={cardDesign}
                  size={'thumbnail'}
                />
              </div>
            );
          }
          return;
        })}
      </div>
    );
  }

  return (
    <>
      {renderCardDesign()}
      {renderCardDesignThumbnails()}
      {renderDescription()}
    </>
  );
}

export default withStyles(styles)(CardDesignSection);
